import gs from "ghostscript4js";
import path from "path";
import fs from "fs";

// -dPDFSETTINGS=/screen   (screen-view-only quality, 72 dpi images)
// -dPDFSETTINGS=/ebook    (low quality, 150 dpi images)
// -dPDFSETTINGS=/printer  (high quality, 300 dpi images)
// -dPDFSETTINGS=/prepress (high quality, color preserving, 300 dpi imgs)
// -dPDFSETTINGS=/default  (almost identical to /screen)

export default async function compressPdf(filePath, filename, mimetype) {
  if (mimetype !== 'application/pdf' && path.extname(filename) !== '.pdf') {
    return;
  }
  console.log(`Compressing PDF "${filePath}"`);
  const setQuality = process.env.PDF_QUALITY || "default";
  const cmd =
      `gs -sDEVICE=pdfwrite -dCompatibilityLevel=1.4 -dPDFSETTINGS=/${setQuality}`
      + ` -dDownsampleColorImages=true -dColorImageResolution=150 -dNOPAUSE -dQUIET -dBATCH`
      + ` -sOutputFile=${filePath}_compressed ${filePath}`;
  await new Promise(function (resolve, reject) {
    gs.execute(cmd, err => {
      if (err) {
        console.error(err);
        reject(err);
      } else {
        // console.log(`PDF compressed to ${filePath}_compressed, renaming to ${filePath}`);
        fs.unlinkSync(filePath);
        fs.renameSync(`${filePath}_compressed`, filePath);
        console.log(`PDF compressed and saved to ${filePath}`);
        resolve(filePath);
      }
    })
  });
}